import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import Logs from './EVV_AZ_Logs/Logs.js';
import { Procedure } from './Procedure/Procedure.js'
import EVV_Reports from '../Reports_V2/EVV_Reports.js';

class EVV_Arizona extends React.Component {
    state = {
        key: 0,
    }

    // Handles the tab change event [(0: Logs), (1: Procedure), (2: Reports)]
    handleSelect = (event, key) => {
        this.setState({ key });
    };

    render() {
        // Tab Logic for: Logs | Procedure | Reports
        let renderComponent = '';
        if (this.state.key === 0) {
            renderComponent = <Logs checkTokenExpiry={this.props.checkTokenExpiry} user={this.props.user} comp_id={this.props.comp_id} />;
        } else if (this.state.key === 1) {
            renderComponent = <Procedure checkTokenExpiry={this.props.checkTokenExpiry} user={this.props.user} comp_id={this.props.comp_id} />
        } else if (this.state.key === 2) {
            renderComponent = <EVV_Reports {...this.props} activeSubKey={'evvReport'} />;
        } else {
            renderComponent = '';
        }

        return (
            <Box>
                {/* Horizontal Navigation */}
                <Tabs
                    value={this.state.key}
                    onChange={this.handleSelect}
                    variant="scrollable"
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        '& .Mui-selected': {
                            backgroundColor: '#f0f0f0',
                            fontWeight: 'bold',
                        },
                    }}
                >
                    <Tab value={0} label="EVV Activity" />
                    <Tab value={1} label="EVV Procedure" />
                    <Tab value={2} label="EVV Reports" />
                </Tabs>

                {/* EVV Logs/Procedure/Reports Render */}
                <Box sx={{ p: 1 }}>{renderComponent}</Box>
            </Box>
        );
    }
}

export default EVV_Arizona;